export default {
    model: 'Модель',
    orthophoto: 'ортофото',
    obliquePhotography: 'наклонная фотография',
    laserPointCloud: 'Облако лазерных точек',
    model3D: '3D модель',
    projectName: 'название проекта',
    switchProject: 'Переключить элементы',
    newProject: 'Новый проект',
    modifyProject: 'Изменить проект',
    modifyThisProject: 'Изменить этот проект',
    deleteThisProject: 'Удалить этот элемент',
    isDelete: 'подтвердить удаление?',
    dataName: 'Имя данных',
    creationTime: 'время создания',
    import: 'Импортировать {name}',
    mergeEdit: 'Объединить редактирование',
    projectNotes: 'Примечания к проекту',
    lastUpdated: 'Последнее обновление',
    modifyDataInformation: 'Изменить информацию о данных',
    modelList: 'Список моделей',
    rotationSettings: 'Настройки вращения',
    rotateAroundAxis: 'Поворот вокруг оси {name}',
    translationSetting: 'Настройка перевода (единица измерения: м)',
    translateAlongAxis: 'Перевести по оси {name}',
    modelReset: 'Сброс модели',
    showTranslationAxis: 'Ось перевода показана здесь',
    showRotationAxis: 'ось вращения показана здесь',
    fileList: 'Список файлов',
    folderName: 'имя папки',
    numberFiles: 'Количество файлов',
    size: 'размер',
    dataSize: 'Размер данных',
    singleFile: 'отдельный файл',
    folderWithPictures: 'Папка с картинками',
    mapPointSelection: 'Выбор точки карты',
    heightMode: 'режим высоты',
    closeToTheSurface: 'близко к поверхности',
    relativeToTheSurface: 'относительно поверхности',
    state: 'состояние',
    altitude: 'Высота',
    processing: 'Обработка',
    dataAnomaly: 'Аномалия данных',
    normal: 'нормальный',
    mapView: 'Просмотр карты',
    modelEditing: 'Редактирование модели',
    tip_PEDN: 'Пожалуйста, введите имя данных',
    tip_PEH: 'Пожалуйста, введите высоту',
    tip_PUFTC: 'Пожалуйста, загрузите файлы, соответствующие спецификациям 3D Tiles!',
    tip_PUFT: 'Примечание. Загрузите файлы, соответствующие спецификации 3D Tiles. Другие форматы пока не поддерживаются.',
    tip_FCBE: 'Файл не может быть пустым',
    tip_FEPR: 'Ошибка формата, пожалуйста, перезалейте!',
    tip_uploadCanceled: 'Загрузка отменена',
    tip_TUFI: 'В папке загрузки отсутствуют файлы obj, пожалуйста, загрузите еще раз!',
    tip_TUFC: 'В папке загрузки может быть только один файл obj, пожалуйста, загрузите еще раз!',
}